import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';
import {Paginator} from 'front-onceforall-core';
import {REGISTRATION_NUMBER_CODE} from 'front-onceforall-core/dist/utils/organisations';
import ListItem from './listItem';
import {TYPES} from './utils/utils';

function OrganisationListView(props) {
  const currentOrganisation = useSelector(state => state.organisation);

  return (
    <>
      {props.loading && <div className="loading-overlay"/>}
      {props.organisations.length === 0 ?
        <div className="table-without-result">
          <Translate value={`${props.type}.search.notFound`}/>
        </div> :
        <table>
          <thead>
            <tr>
              <td><Translate value="organisation.fullName"/></td>
              <td/>
              <td><Translate value={`identificationNumber.${currentOrganisation.country}.${REGISTRATION_NUMBER_CODE}.name`}/></td>
              <td><Translate value="address.postCode"/></td>
              <td><Translate value="address.city"/></td>
              <td><Translate value="address.country"/></td>
              {props.type === TYPES.SUBCONTRACTOR && <td><Translate value="dossier.state.title"/></td>}
              <td/>
            </tr>
          </thead>
          <tbody>
            {props.organisations.map((organisation, index) => (
              <ListItem
                key={index}
                type={props.type}
                organisation={organisation}
                hasInterventionInProject={props.hasInterventionInProject}
                onMenuBtnClick={props.onMenuBtnClick}
                onDeleteOrganisation={props.onDeleteOrganisation}
                dossierCountry={props.dossierCountry}
              />
            ))}
          </tbody>
        </table>
      }
      <Paginator
        totalItems={props.totalCount}
        pageSize={props.pageSize}
        currentPage={props.pageNumber}
        onChangePage={props.onPageChange}
      />

    </>
  );
}

OrganisationListView.propTypes = {
  type: PropTypes.oneOf(Object.values(TYPES)).isRequired,
  organisations: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onMenuBtnClick: PropTypes.func.isRequired,
  onDeleteOrganisation: PropTypes.func.isRequired,
  hasInterventionInProject: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  dossierCountry: PropTypes.string
};

export default OrganisationListView;
